import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Layers",
  "use": "Layers-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol viewBox=\"0 0 18 10\" id=\"Layers\"><path d=\"M0 6h2V4H0v2zm0 4h2V8H0v2zm0-8h2V0H0v2zm4 4h14V4H4v2zm0 4h14V8H4v2zM4 0v2h14V0H4z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol